import React from 'react';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useFeatureFlagContext } from 'contexts/config';

const ConditionalRoute = ({ component: Component = () => null, flagId }) => {
    const ConditionalComponent = (props) => {
        const navigate = useNavigate();
        const featureFlags = useFeatureFlagContext();

        const meetsCondition = isEmpty(flagId) || featureFlags[flagId];

        if (!meetsCondition) {
            navigate.push('/');
        }
        return <Component {...props} />;
    };
    return <ConditionalComponent />;
};

export default ConditionalRoute;
